<template>
  <div class="wrap myoreders-wrap personal-wrap">
    <mu-infinite-scroll :loading="loadShow" loadingText="拼命加载中" class="load" v-if="loadShow" />
    <empty imgpath="/static/images/empty_evaluation_3x.png" emptytext="您还没有商品评价" v-if="getGoodsCommentList.length==0&&!loadShow" btnurl="/main/home" btntext="去逛一逛"></empty>
    <div class=" flex-column flex-item orders-list" v-show="true">
      <div class="orders-list-item" v-for="getGoodsMsg in getGoodsCommentList" v-if="getGoodsCommentList.length!=0">
        <mu-list style="border-bottom: 1px solid #f5f7f9;">
          <myOrdersItem :width="150" :height="150" v-for="(goodsShow,goodsIndex) in getGoodsCommentList" :cartitem="goodsShow" :isRightTriggle="'true'" :key="goodsIndex">
          </myOrdersItem>
        </mu-list>
        <div class="comment-box">
          <p class="comment">{{getGoodsMsg.commDesc}}</p>
          <p class="time">{{getGoodsMsg.commTime}}</p>
          <div class="reply" v-if="0">
            <p class="triangle"></p>
            <p>
              <label class="orange" v-if="getGoodsMsg.commentReplys.length==0">商家回复：</label>
              {{getGoodsMsg.commentReplys&&getGoodsMsg.commentReplys.replyDesc}}
              <p class="time" v-if="getGoodsMsg.commentReplys.length!=0">{{getGoodsMsg.commentReplys&&getGoodsMsg.commentReplys.replyTime}}</p>
            </p>
            <!-- :class="{'border-top-1-E5':index==2} -->
          </div>
          <div class="operate">
            <p class="edit-address fr" @click="editAddress(getGoodsMsg.commId)">编辑</p>
            <p class="delete-address fr" @click="deleteAddress(getGoodsMsg.commId)">删除</p>
            <div class="clear"></div>
          </div>
        </div>
      </div>
      <mu-infinite-scroll :scroller="scroller" :loading="loading" loadingText="" @load="loadMore" />
      <p class="none-goods" v-if="(lastPageNo == currentPage && !loadShow) || (total ==0 && !loadShow) ">没有更多评价啦~</p>
    </div>
    <mu-dialog :open="isDelete" title="删除评论" titleClass="dialogTitle" bodyClass="dialogBody" actionsContainerClass="dialogActionsContainer" @close="isDelete = false">
      确定删除这个评论？
      <mu-flat-button slot="actions" @click="isDelete = false" primary label="否" />
      <mu-flat-button slot="actions" primary label="确定" @click="closedeleteAddress" />
    </mu-dialog>
  </div>
</template>
<script type="text/javascript">
import menus from '@components/menus/menus';
import myOrdersItem from '@components/myOrdersItem/myOrdersItem';
import empty from '@components/empty/empty';
import { mapActions } from 'vuex';
export default {
  data() {
    return {
      loadShow: true,
      isDelete: false, //删除弹框
      cartData: [{
        id: '1',
        title: "防火防盗",
        img: "/static/images/headImg.jpg",
        describe: "油漆门特权订金（特价门型不可用）",
        price: 99999,
        count: 1,
      }],
      num: 10,
      loading: false,
      scroller: null,
      pageNo: 1, //页码
      pageSize: 5, //页量
      total: 0,//z总数量
      lastPageNo:1,//总共页面数量
      currentPage:0,
      commId: '', //订单号
      getGoodsCommentList: [], //获取评价列表
    }
  },
  mounted() {
    this.scroller = document.querySelectorAll('.orders-list')[0];
  },
  methods: {
    ...mapActions({
      pageGoodsComment: 'pageGoodsComment', //获取分页商品评价
      delGoodsComment: 'delGoodsComment', //删除我的商品评价
    }),
   // 加载更多
    loadMore() {
      if(this.lastPageNo == this.pageNo){
        this.loading = false;
      }else{
        this.loading = true;
        this.pageNo ++ ;
        this.getpageGoodsComment();
        setTimeout(() => {          
          this.loading = false
        }, 2000)
      }
      
    },
    //修改评价evaluation
    editAddress(commId) {
      this.$router.push({
        path: '/main/evaluation?commId=' + commId
      })
    },
    //打开当前删除的弹框
    deleteAddress(commId) {
      this.commId = commId;
      this.isDelete = true;
    },
    //关闭弹框
    closedeleteAddress() {
      this.getDelGoodsComment(this.commId);
      this.isDelete = false;
    },
    //删除地址api调用
    getDelGoodsComment(commId) {
      this.delGoodsComment(commId).then(res => {
        this.pageGoodsComment(this.pageNo, this.pageSize);
      })
    },
    getpageGoodsComment(){
      let _this =this;
      //获取我的评价列表
      this.pageGoodsComment([this.pageNo, this.pageSize]).then(result => {
        result.result.forEach(item => {
           _this.getGoodsCommentList.push(item)
        })
        // this.getGoodsCommentList = result.result;
        this.lastPageNo = Number(result.lastPageNo);
        this.currentPage = Number(result.currentPageNo);
        this.total = Number(result.totalCount);
        this.loadShow = false;
      }).catch(error => {
        console.log('error', error)
      });
    }
  },
  watch: {},
  created() {
    this.getpageGoodsComment();
  },
  components: {
    menus,
    myOrdersItem,
    empty,
  }
}

</script>
<style lang="scss" rel="stylesheet/scss">
@import 'personal.scss';

</style>



// WEBPACK FOOTER //
// mycomments.vue?2536206a